import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { PasswordChangeForcePageStore } from 'pages/auth/pages/passwordChangeForce/store/passwordChangeForcePageStore'
import {
  ProviderPasswordChangeForcePage,
  usePasswordChangeForcePageContext,
} from 'pages/auth/pages/passwordChangeForce/context/passwordChangeForceContext'

const PasswordChangeForcePageContent = observer(() => {
  const store = usePasswordChangeForcePageContext()

  return <div>{store.title}</div>
})

export const PasswordChangeForcePage = () => {
  const store = useMemo(() => new PasswordChangeForcePageStore(), [])

  return (
    <ProviderPasswordChangeForcePage value={store}>
      <PasswordChangeForcePageContent />
    </ProviderPasswordChangeForcePage>
  )
}

export default PasswordChangeForcePage
